import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Store from './Redux/store';
import { Provider } from 'react-redux';
import config from './config';
import axios from 'axios';
axios.defaults.baseURL=config.ServerURL;
const rootElement = ReactDOM.createRoot(document.getElementById('root'));
rootElement.render(
    /// Index.js file Changing
    <Provider store={Store}>
        <App />
    </Provider>
  
);
